import { useAuth } from '../../contexts/AuthContext'
import { useUserCheck } from '../../hooks/api/useUserCheck'
import { ManagerIssuesPage } from '../../pages/ManagerIssuesPage'
import { EmployeeIssuesPage } from '../../pages/EmployeeIssuesPage'

export const RoleBasedIssuesPage = () => {
  const { user, loading } = useAuth()
  const { data: userRecord, isLoading } = useUserCheck(user?.id || '')

  if (loading || isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-3 border-gray-400 border-t-transparent border-r-transparent mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  // Employees get the card-based view
  if (userRecord?.role === 'employee') {
    return <EmployeeIssuesPage />
  }

  // Managers and admins get the table-based view
  return <ManagerIssuesPage />
}
